export const labsList = [
  {
    id: 1,
    slug: "workload",
    subTitle: "Performance",
    title: "Live Game Workloads",
    url: "https://coaches.phxapollo.com/live_game_workload/",
    description: "This app provides live game analysis of player workloads.",
  },
];
